/**
 * @file Adds a "keydown" event listener when the component mounts (for esc key) -
 * which calls the "cancel" method if it exists within component
 * Copied from on PR 2403 (https://github.com/padlet/mozart/pull/2403/files)
 */
import { Component, Vue } from 'bits/vue'

interface ComponentMethods {
  _handleEscape: (e: KeyboardEvent) => void
  cancel(_?: string): void
}

@Component({})
export default class EscapeToCancelMixin extends Vue {
  mounted(this: ComponentMethods): void {
    this._handleEscape = (e): void => {
      if (e.keyCode == 27) {
        if (typeof this.cancel === 'function') {
          e.preventDefault()
          this.cancel('esc')
        } else {
          console.error('cancel method not defined for escape to cancel mixin')
        }
      }
    }
    window.addEventListener('keydown', this._handleEscape)
  }
  beforeDestroy(this: ComponentMethods): void {
    window.removeEventListener('keydown', this._handleEscape)
  }
}
